import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { useAuth } from '../context/AuthContext';

export default function ProfileMenu({ user }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Determine profile route based on user role
  const profileRoute = user?.role === 'car workshop' ? '/workshop/profile' : '/profile';

  // Close on click outside
  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      <button
        className="flex items-center gap-1 px-2 py-1 rounded-full hover:bg-gray-700"
        onClick={() => setOpen(!open)}
        aria-label="Profile"
      >
        <UserCircleIcon className="h-8 w-8 text-blue-200" />
        <span className="hidden md:inline text-sm font-semibold">{user?.name || "Profile"}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-gray-900 border border-gray-800 rounded-xl shadow-lg z-20">
          <button
            className="block w-full text-left px-4 py-2 hover:bg-gray-800 text-gray-200"
            onClick={() => {
              setOpen(false);
              navigate(profileRoute);
            }}
          >
            Profile
          </button>
          <button
            className="block w-full text-left px-4 py-2 hover:bg-gray-800 text-red-400"
            onClick={() => {
              setOpen(false);
              logout();
              navigate('/login');
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
